import React from "react";
import { SettingsProfilePage } from "@features/settings/SettingsProfile/SettingsProfilePage.tsx";
import { SettingsNotificationsPage } from "@features/settings/SettingsNotifications/SettingsNotificationsPage.tsx";
import { SettingsCurrencyPage } from "@features/settings/SettingsCurrency/SettingsCurrencyPage.tsx";
import { SettingsBankConnectionPage } from "@features/settings/SettingsBankConnections/SettingsBankConnectionPage.tsx";
import { SettingsAdvancedPage } from "@features/settings/SettingsAdvanced/SettingsAdvancedPage.tsx";
import { Settings2FAPage } from "@features/settings/Settings2FA/Settings2FAPage.tsx";
import { SettingsApiAccessPage } from "@features/settings/SettingsApiAccess/SettingsApiAccessPage.tsx";
import { OnlyAuthenticatedRoute, WithFeatureFlagRoute } from "../routes.tsx";

export default [
  {
    path: "settings",
    element: <OnlyAuthenticatedRoute />,
    children: [
      {
        path: "profile",
        element: <SettingsProfilePage />,
      },
      {
        path: "notifications",
        element: <SettingsNotificationsPage />,
      },
      {
        path: "currency",
        element: <SettingsCurrencyPage />,
      },
      {
        path: "bankConnections/:apiProvider/:id",
        element: <SettingsBankConnectionPage />,
      },
      {
        path: "advanced",
        element: <SettingsAdvancedPage />,
      },
      {
        path: "two-factor-authentication",
        element: <Settings2FAPage />,
      },
      {
        path: "api-access",
        element: (
          <WithFeatureFlagRoute featureFlag="API_TOKENS">
            <SettingsApiAccessPage />
          </WithFeatureFlagRoute>
        ),
      },
    ],
  },
];
